import { Controller } from "stimulus";
import { getCSRFToken, setUpdatedCsrfMetaContent } from "../../util";
import { trackEvent } from "../../analytics";
import { SELECT_API_SUBSCRIBE_CTA } from "../../mixpanel_config";
import { EventContinueToPaymentClick } from "../../events";

export default class extends Controller {
  static values = {
    paymentsUrl: String,
    publishableKey: String,
  }

  static targets = [
    "subscriptionPlanPriceButton",
    "monthlyPlans"
  ]

  connect() {
    this.subscriptionPlanPriceId = null;
    this.paymentGatewayType = "card";

    document.addEventListener(EventContinueToPaymentClick, this.submitForm.bind(this));
  }

  handleSubscriptionPlanChange(e) {
    this.subscriptionPlanPriceId = e.currentTarget.value;
  }

  async submitForm(event) {
    await setUpdatedCsrfMetaContent();

    let payload = {
      subscription_plan_price_id: this.subscriptionPlanPriceId,
      payment_gateway_type: this.paymentGatewayType,
    }

    if (!!event.detail?.customerData) {
      payload.customer_data = event.detail.customerData;
    }

    fetch(this.paymentsUrlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRFToken(),
      },
      body: JSON.stringify(payload),
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
    }).then(data => {
      this.onPostSubmitFormSuccess(data);
    })
    .catch(error => {
      this.onPostSubmitFormError(error);
    });
  }

  onPostSubmitFormSuccess(data) {
    const stripe = Stripe(this.publishableKeyValue);

    if (data.hasOwnProperty("stripe_session_id")) {
      stripe.redirectToCheckout({ sessionId: data.stripe_session_id });
    } else {
      window.location.href = data.redirect_url;
    }
  }

  onPostSubmitFormError(data) {
    Modal.hide('stripe_billing_form_modal');
    Modal.hide('tax_validation_failed_modal')
    Modal.show('payment_failed_modal');
  }
}
